export const FormHeader = ({ step }) => {
    const headers = [
        'مشخصات صادر کننده سفته',
        'اطلاعات دریافت کننده سفته',
        'مشخصات سفته',
    ]

    return (
        <h2 className="text-xl text-center mb-4 sticky top-36 z-20 bg-white p-4">
            {headers[step]}
        </h2>
    )
}
